"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useId, useRef, useState } from "react";
import { useIntl } from "react-intl";
import s from "ui/ReadMore/styles.module.css";
import { cn } from "utils/helpers/cn";
interface ReadMoreProps {
  text: string;
  lines?: number;
  labelContext?: string;
}
const hasHtmlTable = (html: string) => /<table[\s>]/i.test(html);
export default function ReadMore(t0) {
  const $ = _c(31);
  const {
    text,
    lines: t1,
    labelContext
  } = t0;
  const lines = t1 === undefined ? 2 : t1;
  const {
    formatMessage
  } = useIntl();
  const [clamped, setClamped] = useState(true);
  const [showButton, setShowButton] = useState(false);
  const containerRef = useRef(null);
  const id = useId();
  const t2 = clamped ? "show_more" : "show_less";
  let t3;
  if ($[0] !== formatMessage || $[1] !== t2) {
    t3 = formatMessage({
      id: t2
    });
    $[0] = formatMessage;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const readMoreText = t3;
  const containsTable = hasHtmlTable(text);
  const clampClass = containsTable ? "max-h-[3.25em] overflow-hidden" : `line-clamp-${lines}`;
  let t4;
  if ($[3] !== clamped) {
    t4 = () => {
      setClamped(!clamped);
    };
    $[3] = clamped;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleClick = t4;
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      const hasClamping = _temp;
      const checkButtonAvailability = () => {
        if (containerRef.current) {
          setShowButton(hasClamping(containerRef.current));
        }
      };
      checkButtonAvailability();
      window.addEventListener("resize", checkButtonAvailability);
      return () => {
        window.removeEventListener("resize", checkButtonAvailability);
      };
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== clampClass || $[7] !== text) {
    t6 = [clampClass, text];
    $[6] = clampClass;
    $[7] = text;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  useEffect(t5, t6);
  const t7 = clamped && clampClass;
  let t8;
  if ($[9] !== t7) {
    t8 = cn(s.content, "[word-break:break-word]", t7);
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== clamped || $[12] !== showButton) {
    t9 = showButton && {
      "aria-hidden": clamped
    };
    $[11] = clamped;
    $[12] = showButton;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== text) {
    t10 = {
      __html: text
    };
    $[14] = text;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== id || $[17] !== t10 || $[18] !== t8 || $[19] !== t9) {
    t11 = <div ref={containerRef} className={t8} id={id} {...t9} dangerouslySetInnerHTML={t10} />;
    $[16] = id;
    $[17] = t10;
    $[18] = t8;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== clamped || $[22] !== handleClick || $[23] !== id || $[24] !== labelContext || $[25] !== readMoreText || $[26] !== showButton) {
    t12 = showButton && <button type="button" onClick={handleClick} data-test-id="read-more-button" className={cn("cursor-pointer border-0 bg-none font-bold ring-offset-background", "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2")} aria-label={`${readMoreText}: ${labelContext ?? ""}`} aria-controls={id} aria-expanded={!clamped}>{readMoreText}</button>;
    $[21] = clamped;
    $[22] = handleClick;
    $[23] = id;
    $[24] = labelContext;
    $[25] = readMoreText;
    $[26] = showButton;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t11 || $[29] !== t12) {
    t13 = <div className="flex flex-col items-start gap-n1 text-sm">{t11}{t12}</div>;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
function _temp(el) {
  const {
    clientHeight,
    scrollHeight
  } = el;
  return clientHeight !== scrollHeight;
}